// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.same-job-modal__wrapper[data-v-1282b046] {\n  margin: 20px 15px;\n}\n.same-job-modal__text[data-v-1282b046] {\n  margin-bottom: 20px;\n}\n.same-job-modal__btn-wrapper[data-v-1282b046] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  margin: 0 -10px;\n}\n.same-job-modal__btn[data-v-1282b046] {\n  width: auto;\n  margin: 0 10px;\n  padding: 0 20px;\n}\n", ""]);
// Exports
module.exports = exports;
